// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Container, Grid, Image } from "semantic-ui-react";
import "./ApplicationLoader.less";
import * as i18n from "../../config/i18n";
import { ApplicationThemeContext } from "../ApplicationTheme";
import { ApplicationContainer } from "../ApplicationContainer";
import { getApplicationClassName, getClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("loader");
export const ApplicationLoader = props => {
  // eslint-disable-next-line react/prop-types
  const {
    type,
    message
  } = props;
  const {
    variant
  } = React.useContext(ApplicationThemeContext);
  const [messaging, setMessaging] = React.useState(message || i18n.loaderRandomMessage());
  const loader = React.useMemo(() => /*#__PURE__*/_jsxs("div", {
    className: getClassName(className, "dots"),
    children: [/*#__PURE__*/_jsx("div", {
      className: "dot"
    }), /*#__PURE__*/_jsx("div", {
      className: "dot"
    }), /*#__PURE__*/_jsx("div", {
      className: "dot"
    }), /*#__PURE__*/_jsx("div", {
      className: "dot"
    }), /*#__PURE__*/_jsx("div", {
      className: "dot"
    })]
  }), []);
  const messager = React.useMemo(() => /*#__PURE__*/_jsx(SwitchTransition, {
    children: /*#__PURE__*/_jsx(CSSTransition, {
      addEndListener: (node, done) => node.addEventListener("transitionend", done, false),
      classNames: "fade",
      children: /*#__PURE__*/_jsx("span", {
        className: "message",
        children: messaging
      })
    }, messaging)
  }), [messaging]);
  React.useEffect(() => {
    let interval;
    if (!message) {
      interval = setInterval(() => {
        setMessaging(i18n.loaderRandomMessage());
      }, 10000);
    }
    return () => {
      if (!message) {
        clearInterval(interval);
      }
    };
  }, [message]);
  switch (type) {
    case "screen":
      return /*#__PURE__*/_jsxs(Grid, {
        className: getClassName(className, type),
        children: [/*#__PURE__*/_jsx(Grid.Row, {
          className: "header"
        }), /*#__PURE__*/_jsxs(Grid.Row, {
          className: "content",
          centered: true,
          children: [/*#__PURE__*/_jsx(Image, {
            className: getClassName("logo", "colored"),
            "aria-label": variant
          }), /*#__PURE__*/_jsxs(Container, {
            className: "indicator",
            children: [loader, messager]
          })]
        })]
      });
    case "overlay":
      return /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          width: "100%",
          height: "100%"
        },
        children: /*#__PURE__*/_jsx(ApplicationContainer, {
          children: /*#__PURE__*/_jsx(Grid, {
            className: getClassName(className, type),
            children: /*#__PURE__*/_jsxs(Grid.Row, {
              className: "content",
              centered: true,
              children: [/*#__PURE__*/_jsx(Image, {
                className: getClassName("logo", "colored"),
                "aria-label": variant
              }), /*#__PURE__*/_jsxs(Container, {
                className: "indicator",
                children: [loader, messager]
              })]
            })
          })
        })
      });
    default:
      return loader;
  }
};